import { Inject, Injectable, Injector, OnDestroy, OnInit, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DefaultService } from 'build/openapi/project';
import { IIdentifier, IQuestionIdentifier, PayloadSendData, ResponseCheckCodeWithBirthday, ResponseCheckCodeWithoutBirthday, ResponseLoadBankamountData, ResponseLoadConsentData, ResponseLoadQuestionContent, ResponseLoadQuestionList, ResponseLoadUserData, ResponseProjectVersion } from 'build/project/openapi-cast/project/project-openapi-cast.model'
import {ResponseAffected} from 'build/project/openapi-cast/shared/shared-openapi-cast.model';

UntilDestroy()
@Injectable({
   providedIn: 'root'
})

export class ProjectOpenapiCastService implements OnDestroy, OnInit  {

  
   private path_: string = "";
 
   constructor (public sDefault: DefaultService, private injector: Injector, private httpClient: HttpClient, @Optional() @Inject('PATH') p: string) {
      this.path_ = p || './assets/';
      
   }
   ngOnInit(): void {
      this.getProjectVersion().subscribe();
   }

   ngOnDestroy (): void {
      this.path_ = ""; 
   }

   private getProjectVersion (): Observable<ResponseProjectVersion> {
      return this.sDefault.dPSOKV1VersionGet({}, {}).pipe(map(value => <ResponseProjectVersion>value));
   }

   public checkCodeWithBirthday (identifier: IIdentifier): Observable<ResponseCheckCodeWithBirthday> {
      identifier.consultantuuid = sessionStorage.getItem("consultantUuid") || "-1";
      return this.sDefault.dPSOKV1CheckWithCodeBirthdayConsultantuuidGet(identifier, {}).pipe(map(value => <ResponseCheckCodeWithBirthday>value));
   }

   public checkCodeWithoutBirthday (identifier: IIdentifier): Observable<ResponseCheckCodeWithoutBirthday> {
      identifier.consultantuuid = sessionStorage.getItem("consultantUuid") || "-1";
      return this.sDefault.dPSOKV1CheckWithoutCodeConsultantuuidGet(identifier, {}).pipe(map(value => <ResponseCheckCodeWithoutBirthday>value));
   }

   public loadUserData (): Observable<ResponseLoadUserData> {
      return this.sDefault.dPSOKV1LoadUserdataCodeBirthdayConsultantuuidGet(this.getIdentifier(), {}).pipe(map(value => <ResponseLoadUserData>value));
   }

   public loadBankamountData (): Observable<ResponseLoadBankamountData> {
      return this.sDefault.dPSOKV1LoadBankamountCodeBirthdayConsultantuuidGet(this.getIdentifier(), {}).pipe(map(value => <ResponseLoadBankamountData>value));
   }

   public loadConsent (): Observable<ResponseLoadConsentData> {
      return this.sDefault.dPSOKV1LoadConsentCodeBirthdayConsultantuuidGet(this.getIdentifier(), {}).pipe(map(value => <ResponseLoadConsentData>value));
   }

   public loadQuestionList (): Observable<ResponseLoadQuestionList> {
      return this.sDefault.dPSOKV1LoadQuestionlistCodeBirthdayConsultantuuidGet(this.getIdentifier(), {}).pipe(map(value => <ResponseLoadQuestionList>value));
   }

   public sendData (code: string, payload: PayloadSendData): Observable<ResponseAffected> {
      const consultantuuid = sessionStorage.getItem("consultantUuid") || "-1";
      return this.sDefault.dPSOKV1PostDataCodeConsultantuuidPost({code: code, consultantuuid: consultantuuid}, payload).pipe(map(value => <ResponseAffected>value));
   }

   public loadQuestionMetaData (identifier: IQuestionIdentifier): Observable<ResponseLoadQuestionContent> {
      if(!identifier.question_id) return of({} as ResponseLoadQuestionContent);
      return this.sDefault.dPSOKV1LoadQuestionmetadataQuestionIdGet({identifier: identifier.question_id}, {}).pipe(
         map(value => Object.assign(value, Object.fromEntries(Object.entries(value).filter(item => item[1] == "[null]").map(
            item => {
               item[1] = null;
               return item;
            }
         )))),
         map(value => <ResponseLoadQuestionContent> value)
      );
   }

   private getIdentifier (): IIdentifier {
      return {
         code: sessionStorage.getItem('code') ?? '',
         birthday: sessionStorage.getItem('birthday') ?? '01.01.1900',
         consultantuuid: sessionStorage.getItem("consultantUuid") ?? "-1"
      };
   }
}
